import React, {PropTypes} from 'react';
import LocationsBody from './locations-body';
import LocationsHeader from './locations-header';
import SelectedPostingDate from '../../../state/selected-posting-date';

const LocationsTable = props =>
    <section className='locations-table'>
        <LocationsHeader/>
        <LocationsBody
            leadAccount={props.leadAccount}
            leadAccountName={props.leadAccountName}
            locations={props.locations}
            selectedPostingDate={props.selectedPostingDate}
        />
    </section>;

LocationsTable.displayName = 'LocationsTable';
LocationsTable.propTypes = {
    leadAccount: PropTypes.string.isRequired,
    leadAccountName: PropTypes.string.isRequired,
    locations: PropTypes.array.isRequired,
    selectedPostingDate: PropTypes.instanceOf(SelectedPostingDate)
};

export default LocationsTable;



// WEBPACK FOOTER //
// ./src/reimbursement-summary/summary/components/reimbursement-summary-main/locations-accordion/locations-table.js